module.exports = __webpack_public_path__ + "img/module1_icon1.4ece506e.png";